import {
  createNamedContext,
  useRequiredContext,
} from "@keycloak/keycloak-ui-shared";
import { PropsWithChildren, useEffect, useState } from "react";
import { useAdminClient } from "../../admin-client";
import { useRealm } from "../realm-context/RealmContext";
import { fetchAdminUI } from "../auth/admin-ui-endpoint";

type AccessRep = {
  canManage: boolean;
};

type UmPermContextProps = {
  /** 是否持有 um-perm-admin（um-perm 管理端点准入），探测失败一律降级 false */
  canManage: boolean;
};

export const UmPermContext = createNamedContext<
  UmPermContextProps | undefined
>("UmPermContext", undefined);

export const useUmPerm = () => useRequiredContext(UmPermContext);

export const UmPermContextProvider = ({ children }: PropsWithChildren) => {
  const { adminClient } = useAdminClient();
  const { realm } = useRealm();
  const [canManage, setCanManage] = useState(false);

  useEffect(() => {
    const controller = new AbortController();
    // 显式传 realm：本 Provider 在 RealmContext setConfig 生效前挂载，
    // adminClient.realmName 可能仍是旧值（如启动时 master → 随后切到 um）
    fetchAdminUI<AccessRep>(adminClient, "um-perm/access", undefined, realm)
      .then((rep) => {
        if (!controller.signal.aborted) {
          setCanManage(rep.canManage === true);
        }
      })
      .catch((error) => {
        // 端点缺失/无权限等一律降级为不可管理，不进 errorBoundary（不影响整个管理台）
        console.debug("um-perm access probe failed", error);
        if (!controller.signal.aborted) {
          setCanManage(false);
        }
      });
    return () => controller.abort();
  }, [adminClient, realm]);

  return (
    <UmPermContext.Provider value={{ canManage }}>
      {children}
    </UmPermContext.Provider>
  );
};
